declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../../services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../services/actor.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FDService } from '../../../../services/fd.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditTreatmentCycleRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { GenericProcPostRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { S_Methods } from '../../../../../../../src/app/ncs/models/actor/actor';

@Component({
  selector: 'ngbeditcycle',
  templateUrl: './editcycle.modal.html',
  styleUrls: ['./editcycle.modal.scss']
})

export class NgbEditCycleModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;

  @Input() DisplayName: string;
  @Input() Code: number;
  @Input() Gender: string;
  @Input() Age: number;
  @Input() PatientRegNo: string;
  @Input() CycleType: string; 
  @Input() ProtocolName: string;
  @Input() TCModelName: string;
  @Input() ProtocolStartDate: Date;
  @Input() ProtocolEndDate: Date;
  @Input() LMP: Date;
  @Input() CycleNo: number;
  @Input() InfertilityType: string;
  @Input() Remarks: string;
    public ApiResData: ApiResponseModel;
    DOB: NgbDateStruct;
  DateOfBirth: NgbDateStruct;
  UpdatedProtocolEndDate: NgbDateStruct;
    NewDate: Date = new Date();
    public isRequesting: boolean = false;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
        private actorservice: ActorService, private fdservice: FDService, private parserFormatter: NgbDateParserFormatter,
        private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService,
  ) { }
  public UpdatedCycleNo: number;
  public MenstrualCycle: string;
  public UpdatedProtocolName: string;
  public UpdatedInfertilityType: string;
  public UpdatedRemarks: string;
  ngOnInit() {
    this.UpdatedCycleNo = this.CycleNo;
    this.UpdatedProtocolName = this.ProtocolName;
    this.UpdatedInfertilityType = this.InfertilityType;
    this.UpdatedRemarks = this.Remarks;
    if (this.ProtocolEndDate != null) {
      var SValidFrom = new Date(this.ProtocolEndDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.UpdatedProtocolEndDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    }
  EditCycle() {
    var saveReq = new EditTreatmentCycleRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40440;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.CycleNo = this.UpdatedCycleNo;
    saveReq.Code = this.Code;
    //saveReq.MenstrualCycle = this.MenstrualCycle;
    saveReq.ProtocolName = this.UpdatedProtocolName;
    saveReq.InfertilityType = this.UpdatedInfertilityType; 
    saveReq.ProtocolEndDate = new Date(this.parserFormatter.format(this.UpdatedProtocolEndDate));
    saveReq.Remarks = this.UpdatedRemarks;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40440;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
}
